// Black Friday nov/2026 — texto do "Desc. automático" no painel (a regra de cálculo fica no backend:
// App\Support\BlackFridayPromo). Aqui só decide o RÓTULO exibido ao consultor.
//
// Regra: orçamento CRIADO de 01/11/2026 a 30/11/2026 e ainda dentro do prazo (30/11) →
// Santiago/Atacama: PIX 15% / Cartão 12%. Demais regiões e transfers não mudam.
// Sem data de criação (orçamento novo sendo montado agora) vale a data de hoje.

const BF_START = new Date('2026-11-01T00:00:00-03:00');
const BF_END   = new Date('2026-11-30T23:59:59-03:00');

export const BF_PIX_PCT  = 15;
export const BF_CARD_PCT = 12;

export const bfActive = (createdAt) => {
  const now     = new Date();
  const created = createdAt ? new Date(createdAt) : now;
  if (Number.isNaN(created.getTime())) return false;
  return created >= BF_START && created <= BF_END && now <= BF_END;
};

const isHighRegion = (region) => ['santiago', 'atacama'].includes((region || '').toLowerCase().trim());

// Rótulo do desconto automático por região ("PIX x% / Cartão y%").
export const autoDiscountLabel = (region, createdAt) => {
  if (isHighRegion(region)) {
    return bfActive(createdAt)
      ? `PIX ${BF_PIX_PCT}% / Cartão ${BF_CARD_PCT}% · Black Friday`
      : 'PIX 12% / Cartão 10%';
  }
  return 'PIX 7% / Cartão 5%';
};
